export default class Base {
  constructor(form, name, labelText) {
    this.form = form;
    this.name = name;
    this.input = this.form.querySelector(`input[name="${name}"]`);
    this.label = this.input && this.form.querySelector(`label[for="${this.input.id}"]`);
    this.labelText = labelText;
    this.inputContainer = this.input && this.input.closest('.js-text-input');
  }

  addMessage = () => {
    this.clearMessage();

    if (this.inputContainer) {
      this.inputContainer.classList.add('input--visited');
    }

    if (this.label) {
      this.label.classList.add('invalid');
      this.label.innerText = this.labelText + this.message;
    }

    this.input.addEventListener('input', this.clearMessage);
  };

  clearMessage = () => {
    if (this.label) {
      this.label.classList.remove('invalid');
      this.label.innerText = this.labelText;
    }

    this.input.removeEventListener('input', this.clearMessage);
  };

  validate = () => {
    if (this.input && !this.isValid()) {
      this.addMessage();

      return false;
    }
    return true;
  };
}
